import * as actionTypes from './actionTypes';
import axios from 'axios';

export const ArbitratorAcceptRejectSuccess = (response) => {
    return({
        type: actionTypes.ARBITRATOR_ACCEPT_REJECT_SUCCESS,
        status: 'true'
    });
}

export const ArbitratorAcceptRejectError = (response) => {
    return({
        type: actionTypes.ARBITRATOR_ACCEPT_REJECT_ERROR,
        status: 'waiting'
    });
}

export const ArbitratorAcceptRejectFalse = (response) => {
    return({
        type: actionTypes.ARBITRATOR_ACCEPT_REJECT_FALSE,
        status: 'false'
    });
}

export const ArbitratorAcceptReject = (caseId, arbitratorId, status) => {
    let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/arbitratorAcceptReject`;
    
    const data = {
        caseId: parseInt(caseId),
        status: status,
        arbitratorId:arbitratorId
    };
    console.log('ArbitratorAcceptReject api data: '+JSON.stringify(data))
    return (dispatch) => {
        axios.post(url, {
            ...data
        })
        .then((response) => {
            console.log('ArbitratorAcceptReject: response: '+response)
            console.log('ArbitratorAcceptReject: response: '+response.data)
            console.log('ArbitratorAcceptReject: (response.data == true): '+(response.data == true))
            console.log('ArbitratorAcceptReject: (response.data == true): '+(response.data == false))
            console.log('ArbitratorAcceptReject: (response.data == true): '+(response.data == 'error'))
            if (response.data == true){
                dispatch(ArbitratorAcceptRejectSuccess(response));
                window.location.reload()
            }
            else if (response.data == 'error'){
                dispatch(ArbitratorAcceptRejectError(response));
                window.location.reload()
            }
            else if (response.data == false){
                dispatch(ArbitratorAcceptRejectFalse(response));
                window.location.reload()
            }
        })
    };

}